<div class="question">

  @if (question.type !== AnswerType.FreeText) {
    <label [innerHTML]="question.title"
      [attr.for]="question.id"
      [id]="'labelFor-'+ question.id"
      [class.error]="question.isValid===false"
    [class.has-help-text]="!!question.body"></label>
  }
  @if (question.type === AnswerType.FreeText) {
    <h2 class="label"
      [class.error]="question.isValid===false"
      [innerHTML]="question.title"
      [id]="'labelFor-'+ question.id"
      [class.has-help-text]="!!question.body"
      (click)="setFocus()"
    > </h2>
  }


  <div class="form-group">
    @if (question.body) {
      <p>{{question.body}}</p>
    }
    <app-form-question-control
      [question]="question"
      [form]="form"
      [readonly]="readonly"
      [hasFocus]="hasFocus"
    ></app-form-question-control>
  </div>


</div>
